import {
  PERMISSION_LIST,
  PERMISSION_MOD_SELECT_ALL_ID,
} from "@/constants/mod-perms-tool.constants";
import type { GrantedPermission } from "@/types/modular-permissions.types";
import React from "react";
import styles from "./perm-list.module.scss";
import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import classNames from "classnames";
import useModularPermissionsManager from "@/features/mod-perms/hooks/useModularPermissions.hook";
import { BiCheck } from "react-icons/bi";

type Props = {
  delegate: GrantedPermission;
};

const PermList = ({ delegate }: Props) => {
  const { permModRecords } = useModularPermissionsStore();
  const { handleCheckboxToggle } = useModularPermissionsManager();

  return (
    <div className={styles.container}>
      <p>
        {delegate.allPermissionsEnabled ? "All" : delegate.permissionIds.length}{" "}
        selected
      </p>
      <ul className={styles.permList}>
        {PERMISSION_LIST.map((perm) => {
          const isChecked = delegate.permissionIds.includes(perm.id); // Is the permissions checked
          const isPending = permModRecords.some(
            (record) =>
              record.ids.includes(perm.id) &&
              record.delegate === delegate.delegate,
          ); // Is it pending
          const isSelectAll = perm.id === PERMISSION_MOD_SELECT_ALL_ID;
          return (
            <li key={perm.id}>
              <button
                disabled={delegate.allPermissionsEnabled && !isSelectAll}
                onClick={() =>
                  handleCheckboxToggle(isChecked, delegate.delegate, perm.id)
                }
                className={classNames(
                  (isChecked || delegate.allPermissionsEnabled) &&
                    styles.isChecked,
                  isPending && styles.isPending,
                  delegate.allPermissionsEnabled &&
                    !isSelectAll &&
                    styles.indeterminate,
                )}
              >
                {perm.name}
                <div className={styles.checkedTick}>
                  <BiCheck size={25} />
                </div>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PermList;
